// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/arrow-up-to-line.js';

import { paths } from '../generated/arrow-up-to-line';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('arrow-up-to-line', Original, paths);
